import {
  TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO,
  TIPO_PROGRAMACAO_DIARIA_INSPECAO,
  TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS,
} from '../../../constants/ids';

export const MAX_GRUPOS_CELULA = 3;
export const MAX_NSIRS_PREVIEW = 2;

export const getResumoPorTipo = row =>
  (Array.isArray(row?.resumoPorTipo) ? row.resumoPorTipo : []);

export const labelNsirs = nsir => {
  if (!nsir) return '-';
  return nsir.codigo || nsir.titulo || nsir.equipamento || '-';
};

const amostraLength = grupo => {
  if (Array.isArray(grupo?.nsirs) && grupo.nsirs.length) return grupo.nsirs.length;
  if (Array.isArray(grupo?.itens) && grupo.itens.length) return grupo.itens.length;
  return 0;
};

export const amostraRestante = grupo => {
  const qtd = Number(grupo?.quantidade) || 0;
  return Math.max(0, qtd - amostraLength(grupo));
};

/**
 * Resumo tipado do item (lista no formulário / modal).
 * Deslocamento → cidades; Inspeção → NSIRs; Manutenção → placa.
 * Não repete descrição livre (Outros/Folga/etc. → '-').
 */
export const formatItemDescricao = item => {
  if (!item) return '-';

  if (item.cidadeDe || item.cidadePara) {
    return `De: ${item.cidadeDe || '-'} → Para: ${item.cidadePara || '-'}`;
  }

  if (item.nsirCodes?.length) {
    return `NSIRs: ${item.nsirCodes.join(', ')}`;
  }

  if (item.nsirLabels?.length) {
    return `NSIRs: ${item.nsirLabels.join(', ')}`;
  }

  if (item.veiculo || item.veiculoPlaca) {
    return `Veículo: ${item.veiculo || item.veiculoPlaca}`;
  }

  return '-';
};

/**
 * Preview tipado de um grupo de resumoPorTipo (célula da listagem).
 * Inspeção → NSIRs; Deslocamento → cidades; Manutenção → placa; senão só N× Tipo.
 */
export const formatTipoPreview = grupo => {
  if (!grupo) return '';

  const qtd = Number(grupo.quantidade) || 0;
  const tipo = grupo.tipo || 'Outros';
  const prefix = `${qtd}× ${tipo}`;
  const rest = amostraRestante(grupo);

  if (grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_INSPECAO && Array.isArray(grupo.nsirs) && grupo.nsirs.length) {
    const shown = grupo.nsirs.slice(0, MAX_NSIRS_PREVIEW).map(labelNsirs);
    const suffix = rest > 0 ? ` +${rest}` : '';
    return `${prefix} · ${shown.join(', ')}${suffix}`;
  }

  if (
    grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO
    && Array.isArray(grupo.itens)
    && grupo.itens.length
  ) {
    const item = grupo.itens[0];
    const route = `${item.cidadeDe || '-'} → ${item.cidadePara || '-'}`;
    const suffix = rest > 0 ? ` +${rest}` : '';
    return `${prefix} · ${route}${suffix}`;
  }

  if (
    grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS
    && Array.isArray(grupo.itens)
    && grupo.itens.length
  ) {
    const placa = grupo.itens[0].veiculo || grupo.itens[0].veiculoPlaca || '-';
    const suffix = rest > 0 ? ` +${rest}` : '';
    return `${prefix} · ${placa}${suffix}`;
  }

  if (Array.isArray(grupo.itens) && grupo.itens.length) {
    const detail = formatItemDescricao(grupo.itens[0]);
    if (detail && detail !== '-') {
      const suffix = rest > 0 ? ` +${rest}` : '';
      return `${prefix} · ${detail}${suffix}`;
    }
  }

  return prefix;
};

export const STATUS_LABEL = {
  SINCRONIZADA: 'Sincronizada',
  PENDENTE: 'Pendente',
  NAO_SINCRONIZADA: 'Não sincronizada',
  ERROR_SINCRONIZAR: 'Erro ao sincronizar',
};

export const statusLabel = status => STATUS_LABEL[status] || status || '-';
